import React from "react"
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { injectIntl } from "react-intl";
import Loader from "react-loader-spinner";
import Modal from "reboron/DropModal";

import {
    clearP24RestaurantMerchant,
    fetchP24RestaurantMerchant,
    createMerchant,
    attachMerchant,
    detachMerchant
} from "../../../actions/p24RestaurantMerchantActions";
import {
    updateMerchant,
    findP24MerchantsByNip,
    findP24MerchantsByPesel,
    findP24MerchantsByP24MerchantId,
} from "../../../actions/p24MerchantActions";
import P24MerchantForm from "../../../components/p24/P24MerchantForm";
import P24MerchantExistsForm from "../../../components/p24/P24MerchantExistsForm";
import { P24MerchantTaxIdentification } from "../../../constants/P24MerchantTaxIdentification";


// Individual styles for the modal, modal content, and backdrop
const modalStyle = {
    //transform: 'rotate(45deg) translateX(-50%)',
    //width: '80%'
    width: '800px'
};

const backdropStyle = {
    // backgroundColor: 'red',
};

const contentStyle = {
    // backgroundColor: 'blue',
    height: '100%',
};

/**
 * Przycisk z z akcją
 */
const ActionButton = ({ label, onClick }) => {
    return (
        <div className="w3-container w3-padding">

            <div className="w3-bar">
                <button
                    className="w3-btn w3-pink w3-bar-item w3-right w3-margin-right"
                    onClick={onClick}

                >
                    {label}
                </button>
            </div>
        </div>
    )
}

/**
 * Komponent reprezentujący merchantów P24 dla konkretnej restauracji
 */
class RestaurantP24Merchants extends React.Component {

    state = {
        //ładowanie danych merchanta
        loading: true,
        merchantExists: false
    }

    async componentDidMount() {

        this.props.clearP24RestaurantMerchant();

        //ladowanie danych
        try {
            await this.props.fetchP24RestaurantMerchant(this.props.match.params.id);

            this.setState({
                loading: false,
                merchantExists: true
            })
        } catch (error) {
            console.log('error', error);
            //jeśli błąd 404 - dajemy możliwość dobrania lub rejestracji nowego merchanta

            if (error.response && error.response.status === 404) {
                console.log('error 404');
                this.setState({
                    loading: false,
                    merchantExists: false
                })
            }

        }

    }

    /**
     * Akcja na wywolanie rejestracji merchanta 
     */
    handleMerchantRegister = async (restaurantId, merchant) => {

        try {
            await this.props.createMerchant(restaurantId, merchant)
            this.hideModalRegisterMerchant();

            //przywracamy stan w ktorym restauracja ma merchanta
            this.setState({
                merchantExists: true
            })
        } catch (error) {
            console.log('error', error);
            //jeśli błąd 404 - dajemy możliwość dobrania lub rejestracji nowego merchanta

        }
    }

    /**
    * Obsluga aktualizacji merchanta 
    */
    handleMerchantUpdate = (restaurantId, merchant) => {

        this.props.updateMerchant(merchant)

    }

    /**
     * Obsługa przyłączenia merchanta do restauracji
     */
    handleMerchantAttach = async (restaurantId, merchant) => {

        await this.props.attachMerchant(restaurantId, merchant)

        //chowamy modal
        this.hideModalAttachMerchant();

        //przywracamy stan w ktorym restauracja ma merchanta
        this.setState({
            merchantExists: true
        })
    }

    /**
    * Obsługa odłączenia merchanta od restauracji
    */
    handleMerchantDetach = (restaurantId, merchant) => {

        this.props.detachMerchant(restaurantId, merchant)

        //chowamy modal
        this.hideModalDetachMerchant();

        //przywracamy stan w ktorym restauracja nie ma merchanta
        this.setState({
            merchantExists: false
        })
    }

    /**
     * Akcja na wywolanie wyszukania merchanta
     * 
     * @param {Object} p24MerchantTaxIdentification P24MerchantTaxIdentification
     * 
     * @param {Object} taxIdentificationNumber nip or pesel
     */
    handleMerchantExists = async (p24MerchantTaxIdentification, taxIdentificationNumber) => {

        try {
            //wyszukiwanie po Pesel
            if (p24MerchantTaxIdentification.id === P24MerchantTaxIdentification.PESEL.id) {
                await this.props.findP24MerchantsByPesel(taxIdentificationNumber.pesel)
            }

            //wyszukiwanie po Nip
            if (p24MerchantTaxIdentification.id === P24MerchantTaxIdentification.NIP.id) {
                await this.props.findP24MerchantsByNip(taxIdentificationNumber.nip)
            }

            //wyszukiwanie po P24 Merchant
            if (p24MerchantTaxIdentification.id === P24MerchantTaxIdentification.P24_MERCHANT_ID.id) {
                await this.props.findP24MerchantsByP24MerchantId(taxIdentificationNumber.p24MerchantId)
            }

            //czekamy na odpowiedz i dopiero mozemy pokazac modal
            this.showModalAttachMerchant();

        } catch (error) {
            //jesli blad nie pokazujemy modala
            console.log('error', error);

        }

    }

    /**
   * Pokazuje modal z dołączaniem merchanta
   */
    showModalAttachMerchant = () => {
        this.refs.modal_attachMerchant.show();
    }

    /**
     * Chowa modal z dołączaniem merchanta
     */
    hideModalAttachMerchant = () => {
        this.refs.modal_attachMerchant.hide();
    };

    /**
      * Pokazuje modal z odłączaniem merchanta
      */
    showModalDetachMerchant = () => {
        this.refs.modal_detachMerchant.show();
    }

    /**
     * Chowa modal z odłączaniem merchanta
     */
    hideModalDetachMerchant = () => {
        this.refs.modal_detachMerchant.hide();
    };

    /**
      * Pokazuje modal z odłączaniem merchanta
      */
    showModalRegisterMerchant = () => {
        this.refs.modal_registerMerchant.show();
    }

    /**
     * Chowa modal z odłączaniem merchanta
     */
    hideModalRegisterMerchant = () => {
        this.refs.modal_registerMerchant.hide();
    };



    render() {

        if (this.state.loading) {
            return <div className="w3-display-middle"><Loader type="Watch" color="#1797be" height={96} width={96} /></div>;
        }

        if (this.state.merchantExists) {
            return (
                <div>


                    <P24MerchantForm restaurantId={this.props.match.params.id} merchant={this.props.p24RestaurantMerchant} onSubmit={this.handleMerchantUpdate} title="Merchant" sumbitText="Aktualizuj" disabledFields={['p24MerchantId', 'creationType']}/>

                    <ActionButton label="Odłącz merchanta" onClick={this.showModalDetachMerchant} />

                    <Modal ref={"modal_detachMerchant"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                        <P24MerchantForm restaurantId={this.props.match.params.id} merchant={this.props.p24RestaurantMerchant} onSubmit={this.handleMerchantDetach} onCancel={this.hideModalDetachMerchant} title="Czy odłączyć merchanta od restauracji?" sumbitText="Odłącz" cancelText="Anuluj" extendedView={false} disabledFields={['p24MerchantId', 'creationType']}/>
                    </Modal>

                </div>
            )

        } else {
            return (
                <div>


                    <P24MerchantExistsForm onSubmit={this.handleMerchantExists} title="Wyszukaj merchanta" />

                    <br />

                    <ActionButton label="Rejestruj merchanta" onClick={this.showModalRegisterMerchant} />

                    <Modal ref={"modal_registerMerchant"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                        <P24MerchantForm restaurantId={this.props.match.params.id} onSubmit={this.handleMerchantRegister} onCancel={this.hideModalRegisterMerchant} title="Rejestracja merchanta" sumbitText="Rejestruj" cancelText="Anuluj" />
                    </Modal>

                    <Modal ref={"modal_attachMerchant"} modalStyle={modalStyle} backdropStyle={backdropStyle} contentStyle={contentStyle}>
                        <P24MerchantForm restaurantId={this.props.match.params.id} merchant={this.props.p24MerchantsByTaxId} onSubmit={this.handleMerchantAttach} onCancel={this.hideModalAttachMerchant} title="Czy dołączyć merchanta do restauracji?" sumbitText="Dołącz" cancelText="Anuluj" extendedView={false} disabledFields={['p24MerchantId', 'creationType']}/>
                    </Modal>

                </div>
            )
        }

    }
}

RestaurantP24Merchants.propTypes = {
    //identyfikator restauracji
    restaurantId: PropTypes.number.isRequired
}

const mapStateToProps = state => ({
    p24RestaurantMerchant: state.p24RestaurantMerchantReducer.p24RestaurantMerchant,
    p24MerchantsByTaxId: state.p24MerchantReducer.p24MerchantsByTaxId
});


const mapDispatchToProps = ({
    clearP24RestaurantMerchant: clearP24RestaurantMerchant,
    fetchP24RestaurantMerchant: fetchP24RestaurantMerchant,
    createMerchant: createMerchant,
    attachMerchant: attachMerchant,
    detachMerchant: detachMerchant,
    updateMerchant: updateMerchant,
    findP24MerchantsByNip: findP24MerchantsByNip,
    findP24MerchantsByPesel: findP24MerchantsByPesel,
    findP24MerchantsByP24MerchantId:findP24MerchantsByP24MerchantId
});

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
);

export default compose(
    withConnect,
    injectIntl
)(RestaurantP24Merchants);

